<div class="pt-10 px-10 pb-10">
  <div class="flex justify-between items-start mb-4">
    <h1 class="text-2xl font-bold">Administradores</h1>
    <button type="submit" class="bg-primary text-white py-2 px-4 rounded-lg flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="openUserDialog(false)"
      [disabled]="!canCreateUser"
      [matTooltip]="canCreateUser ? '' : 'Você não tem permissão para criar usuários'">
      <mat-icon class="mr-2">add</mat-icon>
      Novo administrador
    </button>
  </div>

  <div class="bg-white shadow rounded-lg p-4 mb-4">
    <div class="relative">
      <mat-icon *ngIf="!isLoading" class="absolute left-2 top-2 text-gray-500">search</mat-icon>
      <div *ngIf="isLoading" class="absolute left-2 top-2 flex items-center justify-center">
        <mat-spinner [diameter]="20" color="primary"></mat-spinner>
      </div>
      <input type="text" placeholder="Buscar administradores..."
        class="w-full p-2 pl-10 border border-gray-200 rounded-lg input-field-focus" [formControl]="searchControl"
        (keydown)="onSearchKeydown($event)" />
    </div>
  </div>

  <div>
    <ngx-datatable class="material" [rows]="users" [columns]="columns" [columnMode]="ColumnMode.flex"
      [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [externalPaging]="true" [count]="page.count"
      [offset]="page.page" [limit]="page.pageSize" (page)="onPage($event)" (sort)="onSort($event)" [messages]="{
          emptyMessage: isLoading ? 'Buscando resultados...' : 'Nenhum resultado encontrado.'
        }">
      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
          <div class="flex items-center justify-between w-full px-4">
            <span class="text-sm text-gray-600">
              Mostrando {{ getStartIndex() }} a {{ getEndIndex() }} de {{ page.count }} resultados
            </span>
            <datatable-pager
              [pagerLeftArrowIcon]="'datatable-icon-left'"
              [pagerRightArrowIcon]="'datatable-icon-right'"
              [pagerPreviousIcon]="'datatable-icon-prev'"
              [pagerNextIcon]="'datatable-icon-skip'"
              [page]="curPage"
              [size]="pageSize"
              [count]="rowCount"
              (change)="onPage($event)">
            </datatable-pager>
          </div>
        </ng-template>
      </ngx-datatable-footer>
      <ngx-datatable-column prop="name" name="Nome" [headerClass]="'text-xs'" [cellClass]="'cell-truncate'" [flexGrow]="6">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex items-center">
            <img [src]="row.avatarUrl" alt="user" class="w-8 h-8 rounded-full mr-2 flex-shrink-0 self-center"
              onerror="this.src='assets/img/profile_placeholder.png'" />
            <div class="flex flex-col justify-center min-w-0">
              <span class="text-sm font-semibold text-primary-dark truncate" [title]="row.name">{{ row.name }}</span>
              <div class="text-xs text-gray-500">Desde {{ formatDate(row.createdAt) }}</div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="email" name="Email" [headerClass]="'text-xs'" [cellClass]="'cell-truncate'" [flexGrow]="6" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span class="text-sm text-primary-gray truncate" [title]="row.email">
            {{ row.email }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="role" name="Cargo" [headerClass]="'text-xs'" [cellClass]="'cell-truncate'" [flexGrow]="5" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span class="text-sm text-primary-gray truncate" [title]="row.role.name">
            {{ row.role.name }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column prop="isActive" name="Status" [headerClass]="'text-xs'" [flexGrow]="3" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span class="px-2 py-1 rounded-full text-xs" [ngClass]="{
                    'text-item-green-text bg-item-green-bg': row.active == true,
                    'text-item-yellow-text bg-item-yellow-bg': row.active != true
                  }">
            {{ row.active ? 'Ativo' : 'Inativo' }}
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Ações" [headerClass]="'text-xs'" [flexGrow]="3" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="flex flex-nowrap pr-2">
            <button mat-icon-button (click)="openUserDialog(true, row)"
              [disabled]="!canUpdateUser"
              [matTooltip]="canUpdateUser ? 'Editar' : 'Sem permissão para editar'">
              <span class="material-symbols-outlined small-icon" [ngClass]="canUpdateUser ? 'text-gray-500' : 'text-gray-300'">edit_square</span>
            </button>
            <button mat-icon-button (click)="toggleIsActive(row)"
              *ngIf="row.id != currentUser?.id"
              [disabled]="!canUpdateUser"
              [matTooltip]="!canUpdateUser ? 'Sem permissão' : (row.active ? 'Inativar' : 'Ativar')">
              <mat-icon class="small-icon" [ngClass]="canUpdateUser ? 'text-gray-500' : 'text-gray-300'">
                {{ row.active ? 'close' : 'replay' }}
              </mat-icon>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="h-24"></div>
</div>